(() => {
    "use strict";

    let modal = null;
    let modalImage = null;
    let modalCaption = null;
    let closeButton = null;
    let previousFocusedElement = null;
    let closeTimer = null;


    /* ======================================================
       MODAL CREATION
       ====================================================== */

    function create() {
        if (modal) {
            return;
        }

        modal = document.createElement("div");

        modal.className = "fr-artifactModal";
        modal.setAttribute("role", "dialog");
        modal.setAttribute("aria-modal", "true");
        modal.setAttribute("aria-label", "Photograph");
        modal.setAttribute("aria-hidden", "true");

        modal.innerHTML = `
            <div class="fr-artifactModal-content">

                <button
                    class="fr-artifactModal-close"
                    type="button"
                    aria-label="Close photograph"
                >
                    ×
                </button>

                <img
                    class="fr-artifactModal-image"
                    src=""
                    alt=""
                >

                <div class="fr-artifactModal-caption"></div>

            </div>
        `;

        document.body.appendChild(modal);

        modalImage = modal.querySelector(
            ".fr-artifactModal-image"
        );

        modalCaption = modal.querySelector(
            ".fr-artifactModal-caption"
        );

        closeButton = modal.querySelector(
            ".fr-artifactModal-close"
        );

        closeButton.addEventListener(
            "click",
            close
        );

        modal.addEventListener("click", (event) => {
            if (event.target === modal) {
                close();
            }
        });

        document.addEventListener("keydown", (event) => {
            if (
                event.key === "Escape" &&
                modal.classList.contains("is-open")
            ) {
                close();
            }
        });
    }


    /* ======================================================
       MODAL OPEN
       ====================================================== */

    function open(options = {}) {
        const {
            src = "",
            alt = "",
            caption = "",
            trigger = null
        } = options;

        if (!src) {
            return;
        }

        create();

        if (closeTimer) {
            window.clearTimeout(closeTimer);
            closeTimer = null;
        }

        previousFocusedElement =
            trigger ||
            document.activeElement;

        const preload = new Image();

        preload.onload = () => {

            modalImage.src = src;
            modalImage.alt = alt;
            modalCaption.textContent = caption;

            modal.classList.add("is-open");
            modal.setAttribute("aria-hidden", "false");

            document.body.classList.add(
                "fr-artifactModal-open"
            );

            closeButton.focus();

        };

        preload.src = src;
    }


    /* ======================================================
       MODAL CLOSE
       ====================================================== */

    function close() {
        if (
            !modal ||
            !modal.classList.contains("is-open")
        ) {
            return;
        }

        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");

        document.body.classList.remove(
            "fr-artifactModal-open"
        );

        closeTimer = window.setTimeout(() => {
            if (!modal.classList.contains("is-open")) {
                modalImage.removeAttribute("src");
                modalImage.alt = "";
                modalCaption.textContent = "";
            }

            closeTimer = null;
        }, 220);

        if (
            previousFocusedElement &&
            typeof previousFocusedElement.focus === "function"
        ) {
            previousFocusedElement.focus();
        }

        previousFocusedElement = null;
    }


    /* ======================================================
       PUBLIC API
       ====================================================== */

    window.artifactsModal = {
        open,
        close
    };

})();